import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { vscDarkPlus } from 'react-syntax-highlighter/dist/esm/styles/prism';

const CodeViewer = ({ code, language }) => {
  return (
    <SyntaxHighlighter
      language={language}
      style={vscDarkPlus}
      showLineNumbers
      customStyle={{
        margin: 0,
        borderRadius: 0,
        background: '#0d1117',
        fontSize: '13px',
        lineHeight: '1.6',
        padding: '1.25rem 1.5rem',
      }}
      lineNumberStyle={{
        color: '#30363d',
        minWidth: '2.5em',
        paddingRight: '1em',
        userSelect: 'none',
      }}
    >
      {code}
    </SyntaxHighlighter>
  );
};

export default CodeViewer;
